import { DomainRule } from '../../types';

export interface EmbeddedSelectorRequiredRuleDto {
  selector: string;
}

export const EmbeddedSelectorRequiredRuleKey = 'embeddedSelectorRequiredRule';

export const EmbeddedSelectorRequiredRule = (dto: EmbeddedSelectorRequiredRuleDto): DomainRule => {
  if (!dto.selector?.trim()) {
    return {
      result: 'fail',
      ruleKey: EmbeddedSelectorRequiredRuleKey,
    };
  }

  return {
    result: 'pass',
    ruleKey: null,
  };
};
